/**
 * Format angka ke Rupiah (IDR)
 * @param {number|string} value - Nilai yang akan diformat
 * @returns {string} - Contoh: "Rp12.345.678"
 */
export function formatRupiah(value) {
  const num = Number(value) || 0;
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(num);
}
